import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { ImportWizardUploadService } from '../service/import-wizard-upload.service';
import { MatStepper } from '@angular/material/stepper';
import { ErzeugungsanlagenImportReport } from '../model/erzeugungsanlagen-import-report';
import { DialogService } from '../../service/common/dialog/dialog.service';
import { ErzeugungsanlagenRefreshService } from '../../service/erzeugungsanlage/erzeugungsanlagen-refresh.service';
import {
    ErzeugungsanlageImportJob,
    ErzeugungsanlageImportJobPhase, initialImportJob,
} from '../../domain/model/erzeugungsanlage-import-job';
import { RoutingService } from '../../service/common/routing/routing.service';
import { Router } from '@angular/router';
import { PrinterService } from '../../service/common/printer/printer.service';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';

@Component({
    selector: 'redispatch-import-wizard',
    templateUrl: './import-wizard.component.html',
    styleUrls: [
        './import-wizard.component.scss',
    ],
    standalone: false,
})
export class ImportWizardComponent {

    public readonly PRINT_ELEMENT_ID = PrinterService.PRINT_ELEMENT_ID;

    public loading = false;

    private jobCheckerTimeout: any;
    public jobId?: number;
    public importReport: ErzeugungsanlagenImportReport = null;

    public backendFailure: any = null;

    public selectedFile: File;

    @ViewChild('stepper', { static: true }) stepper: MatStepper;

    public job: ErzeugungsanlageImportJob;

    public ErzeugungsanlageImportJobPhase = ErzeugungsanlageImportJobPhase;

    private uploadService = inject(ImportWizardUploadService);
    private erzeugungsanlagenRefreshService = inject(ErzeugungsanlagenRefreshService);
    private dialogService = inject(DialogService);
    private routingService = inject(RoutingService);
    private router = inject(Router);
    private printerService = inject(PrinterService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    containsLogs(): boolean {
        return this.importReport?.transformations.some((transformation) => transformation.log.length) ||
            !!this.importReport?.delta?.amountOfDeletedErzeugungsanlagen ||
            !!this.importReport?.delta?.amountOfDeletedErzeugungsanlagenWithPlanwerten;
    }

    handleFileChange(selectedFile: File) {
        this.selectedFile = selectedFile;
    }

    async upload(dryRun: boolean) {
        this.loading = true;
        this.importReport = null;
        this.job = initialImportJob;
        this.backendFailure = null;
        const file = this.selectedFile;
        try {
            const result = await this.uploadService.uploadExcelAsync(
                this.teilgebietSelectionService.getSelectedStadtwerkeId(),
                file,
                dryRun,
            ) as any;
            this.jobId = result.body.jobId;
            this.jobCheckerTimeout = setInterval(() => this.checkJobDone(dryRun), 756);
            this.stepper.next();
        } finally {
            this.loading = false;
        }
    }

    private async checkJobDone(dryRun: boolean) {
        try {
            this.job = await this.uploadService.checkImportJob(this.jobId);
            this.changeDetectorRef.markForCheck();
            if (this.job.done) {
                if (this.job.report) {
                    setTimeout(() => { // typically the finalization is so quick that the user doesn't see all of the checkboxes green,
                        // so the timeout is just for the feel :)
                        this.importReport = JSON.parse(this.job.report);
                        this.changeDetectorRef.markForCheck();
                        clearInterval(this.jobCheckerTimeout);
                    }, 842);
                    if (!dryRun) {
                        this.erzeugungsanlagenRefreshService.requestRefresh();
                    }
                }
            }
        } catch (e) {
            clearInterval(this.jobCheckerTimeout);
            this.backendFailure = e;
        }
    }

    async close() {
        this.dialogService.close();
        this.router.navigate([
            this.routingService.erzeugungsanlagePath(),
        ], { queryParams: {} });
    }

    async print() {
        await this.printerService.print();
    }

}
